import { useMemo } from 'react';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

/* eslint-disable i18next/no-literal-string -- YouGov wire metric keys, not copy */
const KEY_BY_METRIC: Record<string, string> = {
  aided: 'awareness',
  consider: 'consideration',
  likelybuy: 'purchaseIntent',
  attention: 'attention',
  adaware: 'adAwareness',
  wom: 'wordOfMouth',
  buzz: 'buzz',
  impression: 'impression',
  reputation: 'reputation',
  quality: 'quality',
  value: 'value',
  recommend: 'recommend',
  satisfaction: 'satisfaction',
  current_own: 'currentOwn',
  former_own: 'formerOwn',
};
/* eslint-enable i18next/no-literal-string */

/**
 * A factory rather than a constant: resolving `t()` at module scope would freeze
 * the English strings at import.
 */
export function buildMetricLabels(
  t: TFunction | ((key: string) => string),
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(KEY_BY_METRIC).map(([metric, key]) => [
      metric,
      (t as (k: string) => string)(`analysisResult.marketingPerformance.${key}`),
    ]),
  );
}

/** Metric-key labels for the `analysis` namespace, memoised on the translator. */
export function useMetricLabels(): Record<string, string> {
  const { t } = useTranslation('analysis');
  return useMemo(() => buildMetricLabels(t as (key: string) => string), [t]);
}
